import React, { useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/freezeLifecycleSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import CurrentlyFrozenView from "./smartComponents/CurrentlyFrozenView";
import FreezeHistoryView from "./smartComponents/FreezeHistoryView";
import ViewSelector from "./smartComponents/ViewSelector";
import { VIEW_OPTIONS } from "./constants";
import "./freezeLifecycle.scss";

const FreezeLifecycleModule = (props) => {
  const dispatch = useDispatch();

  const initialRequest = useSelector((state) => state.freezeLifecycle.initialRequest);
  const isLoading = useSelector((state) => state.freezeLifecycle.isLoading);
  const moduleView = useSelector((state) => state.freezeLifecycle.selectedFilters.moduleView);

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content =
    moduleView.id === VIEW_OPTIONS[0].id ? <CurrentlyFrozenView /> : <FreezeHistoryView />;

  return (
    <div id="module-date-filters">
      <div id="freezeLifecycle">
        <SectionToggle
          autoHeight
          title="Freeze Lifecycle"
          isLoading={isLoading}
          content={content}
          learnMore={<ViewSelector />}
        />
      </div>
    </div>
  );
};

export default memo(FreezeLifecycleModule);
